import advisorhq from "../../apis/advisorhq";
import * as types from "../types";
import { HIDE_MODAL, LOADING } from "../types";
import * as notifications from "../../notifications";
import { EHR_REQUEST_MODAL } from "../../components/modals";

export const generateEHRRequest = (caseDocumentId, caseId, values) => async dispatch => {
  dispatch({ type: LOADING, payload: { ehr: true } });
  try {
    let result = await advisorhq.post(`/life_settlement/api/ehr_request/${caseDocumentId}/${caseId}/`, values);
    const response = await advisorhq.get("/life_settlement/api/case_file/" + caseDocumentId + "/");
    dispatch({ type: types.FETCH_CASE_FILE, payload: response.data });
    return result.data;
  } catch (e) {
    notifications.error(`Problem Processing EHR Request: ${e}`);
    dispatch({ type: HIDE_MODAL, payload: EHR_REQUEST_MODAL });
  } finally {
    dispatch({ type: LOADING, payload: { ehr: false } });
  }
};
